import { render } from "./ParticlesSystemPage.vue?vue&type=template&id=4cdf5f50"
import script from "./ParticlesSystemPage.vue?vue&type=script&lang=js"
export * from "./ParticlesSystemPage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Threejs\\VuejsThreejsForDemo-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__